import { useSyncExternalStore } from 'react'
import { websocketStore } from './websocketStore'

export function useWebSocketStore<T>(selector: (state: (typeof websocketStore)['getSnapshot']) => T): T {
  return useSyncExternalStore(websocketStore.subscribe, () => selector(websocketStore.getSnapshot))
}
